import isPropControlled from './isPropControlled';

export default function isDateControlled({
  range,
  date,
  startDate,
  endDate,
}: {
  range?: boolean;
  date?: Date | null;
  startDate?: Date | null;
  endDate?: Date | null;
}) {
  if (range) {
    return isPropControlled(startDate) || isPropControlled(endDate);
  }

  return isPropControlled(date);
}
